module.exports = __webpack_public_path__ + "img/pentair.8c9d577a.png";